import { useMutation } from '@tanstack/react-query';
import { createRequest } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';

/**
 * Hook containing mutation function for creating a Production Request.
 */
export const useCreateRequest = () =>
  useMutation({
    /**
     * mutateFn - Function to call the createRequest api.
     * @param {Pella.ProductionRequestAPI.CreateRequestInput} input - The inputs for creating the Production Request.
     */
    mutationFn: (input) => createRequest(input),
    onSuccess: () => toast.success('Request submitted successfully!'),
    onError: () => toast.error('Error creating request.'),
  });
